import {
  Cpu,
  CreditCard,
  Database,
  FolderKanban,
  HardDrive,
  Layers,
  PackageOpen,
  Receipt,
  Settings,
  Shield,
  Sparkles,
  Users,
  Zap,
} from 'lucide-react';

export type NavChild = {
  to: string;
  labelKey: string;
  icon: React.ComponentType<{ className?: string }>;
};

export type NavItem = {
  to: string;
  labelKey: string;
  icon: React.ComponentType<{ className?: string }>;
  adminOnly?: boolean;
  children?: NavChild[];
};

/**
 * Single source of truth for the dashboard navigation tree, shared by the
 * desktop sidebar (`DashboardSidebar`) and the mobile drawer (`MobileNav`)
 * so the two never drift apart.
 */
export const navItems: NavItem[] = [
  { to: '/dashboard/projects', labelKey: 'nav.projects', icon: FolderKanban },
  { to: '/dashboard/deployments', labelKey: 'nav.deployments', icon: Zap },
  { to: '/dashboard/models', labelKey: 'nav.models', icon: Layers },
  { to: '/dashboard/model-advisor', labelKey: 'nav.modelAdvisor', icon: Sparkles },
  { to: '/dashboard/gpu-explorer', labelKey: 'nav.gpuExplorer', icon: Cpu },
  { to: '/dashboard/billing', labelKey: 'nav.billing', icon: CreditCard },
  { to: '/dashboard/settings', labelKey: 'nav.settings', icon: Settings },
  {
    to: '/dashboard/admin',
    labelKey: 'nav.admin',
    icon: Shield,
    adminOnly: true,
    children: [
      { to: '/dashboard/admin/users', labelKey: 'nav.adminChildren.users', icon: Users },
      { to: '/dashboard/admin/models', labelKey: 'nav.adminChildren.models', icon: Database },
      { to: '/dashboard/admin/devices', labelKey: 'nav.adminChildren.devices', icon: Cpu },
      { to: '/dashboard/admin/instances', labelKey: 'nav.adminChildren.instances', icon: HardDrive },
      {
        to: '/dashboard/admin/opentofu-cache',
        labelKey: 'nav.adminChildren.opentofuCache',
        icon: PackageOpen,
      },
      { to: '/dashboard/admin/billing', labelKey: 'nav.adminChildren.billing', icon: Receipt },
    ],
  },
];
